export const Panel = ({ titulo, children, className = "", testId }) => (
  <div data-testid={testId} className={`bg-white rounded-xl shadow-sm border border-slate-200 ${className}`}>
    <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
      <h2 className="text-[15px] font-medium text-slate-800">{titulo}</h2>
      <div className="flex items-center gap-1.5" aria-hidden="true">
        <span className="w-2.5 h-2.5 rounded-full bg-teal-400" />
        <span className="w-2.5 h-2.5 rounded-full bg-amber-400" />
        <span className="w-2.5 h-2.5 rounded-full bg-pink-400" />
      </div>
    </div>
    <div className="p-5">{children}</div>
  </div>
);
